import axiosInstance from './axiosInstance';

// Save user scan log
export const saveUserLog = async (usersLog) => {
  try {
    const response = await axiosInstance.post('/Corrohealth/gatemen/scan', usersLog);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  saveUserLog,
};


